"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentryQuickCapture = void 0;
const Sentry = __importStar(require("@sentry/browser"));
const is_defined_1 = require("../is-defined");
const getMessage = (exception) => {
    if (typeof exception === 'string')
        return exception;
    const message = exception?.message;
    return typeof message === 'string' && message.length > 0 ? message : undefined;
};
const toException = (exception) => {
    const type = exception instanceof Error ? exception.name : 'non-Error exception';
    const reported = new Error(type);
    reported.name = getMessage(exception) ?? type;
    if (exception instanceof Error) {
        reported.stack = exception.stack;
    }
    return reported;
};
const sentryQuickCapture = (exception, extra) => {
    Sentry.captureException(toException(exception), (scope) => {
        scope.setTag('scope', 'sentryQuickCapture');
        if ((0, is_defined_1.isValue)(extra)) {
            scope.setContext('variables', extra);
        }
        return scope;
    });
};
exports.sentryQuickCapture = sentryQuickCapture;
